module.exports = __webpack_public_path__ + "img/pow-background.aa8884f.jpg";